import React, { useEffect, useRef, useState } from "react";
import { useApp } from "../context/AppContext";
import api, { API } from "../api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { ImagePlus, Trash2 } from "lucide-react";

export const EntityLogoUpload = ({ entityId }) => {
  const { t } = useApp();
  const [ver, setVer] = useState(Date.now());
  const [has, setHas] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    api.get(`/entities/${entityId}/settings`).then((r) => setHas(!!r.data.logo_path)).catch(() => setHas(false));
  }, [entityId, ver]);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/entities/${entityId}/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(t("logo.saved"));
      setVer(Date.now());
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : t("msg.error"));
    } finally { if (ref.current) ref.current.value = ""; }
  };
  const remove = async () => {
    try { await api.delete(`/entities/${entityId}/logo`); toast.success(t("msg.deleted")); setVer(Date.now()); }
    catch { toast.error(t("msg.error")); }
  };

  return (
    <div data-testid="entity-logo-upload">
      <Label>{t("logo.title")}</Label>
      <div className="mt-1 flex items-center gap-3">
        <div className="h-16 w-40 rounded-md border border-dashed border-border bg-muted/30 flex items-center justify-center overflow-hidden">
          {has ? <img src={`${API}/entities/${entityId}/logo?v=${ver}`} alt="logo" className="max-h-14 max-w-[150px] object-contain" data-testid="entity-logo-preview" />
               : <span className="text-[11px] text-muted-foreground" data-testid="entity-logo-empty">{t("logo.none")}</span>}
        </div>
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="entity-logo-input" />
        <Button type="button" size="sm" variant="outline" onClick={() => ref.current?.click()} data-testid="entity-logo-button">
          <ImagePlus className="h-4 w-4 mr-2" />{has ? t("logo.replace") : t("logo.upload")}
        </Button>
        {has && <Button type="button" size="icon" variant="ghost" onClick={remove} data-testid="entity-logo-delete"><Trash2 className="h-4 w-4 text-destructive" /></Button>}
      </div>
      <p className="text-[11px] text-muted-foreground mt-1">{t("logo.hint")}</p>
    </div>
  );
};
